import React from "react";
import SubTitle from "../../components/common/SubTitle";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import AdminOrgMoreMain from "../../components/organization/AdminOrgMoreMain";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import { Box } from "@mui/material";
export default function AdminOrgMore() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        {localStorage.getItem("selectedApp") === "schoolTrack" ? (
          <SchoolBusNavMenu />
        ) : (
          <NavMenu />
        )}
        <AdminOrgMoreMain />
      </Box>
      <Footer />
    </Box>
  );
}
